module.exports = "<div id=\"admin-events-event\">\n\t<div class=\"row wrapper border-bottom white-bg page-heading\"\n\t ng-if=\"eventName\">\n\t\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n\t\t\t<h2>{{eventName}}</h2>\n\t\t</div>\n\t</div>\n\t<div class=\"wrapper wrapper-content\">\n\t\t<div ui-view=\"a\"></div>\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/admin/events/event/views/base/template.html
// module id = 1223
// module chunks = 0